import type { Theme } from "@mui/material/styles";

/** Animação padronizada dos bottom sheets mobile. */
export function getMobileSheetSlideProps(theme: Theme) {
  return {
    easing: {
      enter: theme.transitions.easing.easeOut,
      exit: theme.transitions.easing.sharp,
    },
    timeout: { enter: 480, exit: 360 },
  };
}

export function getMobileSheetTransitionDuration() {
  return { enter: 480, exit: 360 };
}
